import React, { useState, useEffect, useRef } from "react";
import { Navigate, json, useNavigate } from 'react-router';
import { Bar, Doughnut, Line, Pie } from "react-chartjs-2";
import { Chart, ChartComponent } from "chart.js/auto";
import { Box, Button, Divider, Drawer, Grid, Icon, Link, Paper, Typography } from "@mui/material";
import HailIcon from "@mui/icons-material/Hail";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import ChartPieChartOutlabels from "@energiency/chartjs-plugin-piechart-outlabels";
import iconfortotalinvestment from "../icons/1.png";
import iconforcurrentvalue from "../icons/2.png"; 
import iconfortotalpnl from "../icons/3.png"; 
import iconforstartups from "../icons/6.png"; 
import iconforlatestdate from "../icons/7.png"; 
import iconfordomains from "../icons/8.png"; 
import iconforfvlogo from "../icons/fvlogo.png"; 
// import iconforfvlogofav from "./icons/fvlogo.ico"; 
// import favicon from "./icons/favicon.ico"; 
import favicon from "../icons/fvlogo.ico"; 
import LogoutIcon from '@mui/icons-material/Logout';
import { color } from "chart.js/helpers";
import { Helmet } from 'react-helmet';
import { left } from "@popperjs/core";
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import MenuIcon from '@mui/icons-material/Menu';import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import axios from "axios";

const pluginccbc = {
  id: "customCanvasBackgroundColor",
  beforeDraw: (chart, args, options) => {
    const { ctx } = chart;
    ctx.save();
    ctx.globalCompositeOperation = "destination-over";
    ctx.fillStyle = options.color || "transparent";
    ctx.fillRect(0, 0, chart.width, chart.height);
    ctx.restore();
  },
};

Chart.register(ChartPieChartOutlabels);



function Dashh() {

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const formatter = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
  });
  
  // Data table for investor
  const [originalData, setoriginalData] = useState([]); // Original data loaded for the logged on investor
  const [v1inv, setv1inv] = useState([]); // Copy of the original data on which the data is loaded  
  
  // Measures calculated out of the v1inv data
  const [total_inv, settotal_inv] = useState([]);
  const [current_value, setcurrent_value] = useState([]);
  const [pnl, setpnl] = useState([]);
  const [pnl_percent, setpnl_percent] = useState([]);
  const [funds_invested, setfunds_invested] = useState([]);
  const [startups_covered, setstartups_covered] = useState([]);  
  const [domains_covered, setdomains_covered] = useState([]);  
  const [latest_date, setlatest_date] = useState([]);  
  const [wealth_manager, setwealth_manager] = useState([]);   
  const [rlatest_date, setrlatest_date] = useState([]);
  const [current_date, setcurrent_date] = useState([]);  
  const [iname, setiname] = useState([]);
  const [iid, setiid] = useState([]);
  const [tdata, settdata] = useState([]);  

  let val = 0;


  // for filter selection menu
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setOpen(false);
    }
  };
  //_____________________________________

  // Logout link function
  const [logoutData, setlogoutData] = useState(null);
  const handleLinkClickfv = async () => {
    try {
      localStorage.removeItem("finvolveInvestorData")
      Navigate("/investor-login")
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {    
    async function fetchData() {   
      const finvolveInvestorData = JSON.parse(localStorage.getItem("finvolveInvestorData"));
      // one set of data for all measures and visuals for investors
      const responsev1inv = await fetch(`${API_BASE_URL}/api/investor/investments/${finvolveInvestorData?.email}`,{headers: {
        Authorization: `Bearer ${finvolveInvestorData?.jwt}`, 
      }});
      const {data} = await responsev1inv.json();
      
      const v1inv = data?.investments    
      setv1inv(v1inv);  
      setoriginalData(v1inv);

      // Calculations for the Measures below

      // Total Investments      
      const sumIvalL = v1inv.reduce((accumulator, currentValue) => {
        return accumulator + parseFloat(currentValue.ival_l);
      }, 0);      
      settotal_inv(sumIvalL);      

      // Current Value Total      
      const sumCvalL = v1inv.reduce((accumulator, currentValue) => {
        return accumulator + parseFloat(currentValue.Cval_l);
      }, 0);      
      setcurrent_value(sumCvalL);
      
      // Unrealized P&L Value Total      
      const pnl = v1inv.reduce((accumulator, currentValue) => {
        return accumulator + parseFloat(currentValue.pnl);
      }, 0);      
      setpnl(pnl);
            
      // Funds Invested      
      const distinctFundsCount = [...new Set(v1inv.map(investment => investment.fundname))].length;
      setfunds_invested(distinctFundsCount);
      
      // Startups Covered
      const distinctSUCount = [...new Set(v1inv.map(investment => investment.startupname))].length;
      setstartups_covered(distinctSUCount);
      
      // Domains Covered
      const distinctdomainCount = [...new Set(v1inv.map(investment => investment.SU_Domain))].length;
      setdomains_covered(distinctdomainCount);

      // Use reduce to find the latest date
      const latestDate = v1inv.reduce((latest, item) => {
        const itemDate = new Date(item.issuedate2);
        return itemDate > latest ? itemDate : latest;
      }, new Date('2015-01-01'));
      // Format the latest date as 'dd-Mmm-yyyy'
      const formattedDate = latestDate.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      });
      setlatest_date(formattedDate);    
      
      // wealth_manager
      const wealthmanagers = [...new Set(v1inv.map(item => item.wealthmanager))];
      setwealth_manager(wealthmanagers);
      
      //rlatest_date
      const rlatest_date = v1inv?.reduce((acc, curr) => {
        const accDate = new Date(acc.Cdate2);
        const currDate = new Date(curr.Cdate2);
        return accDate > currDate ? acc : curr;
      }).Cdate2;
      
      setrlatest_date(rlatest_date);
      
      //current_time_am_pm
      const dateObj = new Date();
      const day = dateObj.getDate();
      const month = dateObj.toLocaleString('default', { month: 'short' });
      const year = dateObj.getFullYear();
      setcurrent_date(`${day}-${month}-${year}`);

      // Investor Name
      const iname = [...new Set(v1inv.map(item => item.investor))];
      setiname(iname);
      
      // Investor ID
      const iid = [...new Set(v1inv.map(item => item.ilogin))];
      setiid(iid);
            
      //reverse chronologically arranged dates for the table data
      settdata([...v1inv].sort((a, b) => {
        const dateA = new Date(a.issuedate2);
        const dateB = new Date(b.issuedate2);
        return dateB - dateA;
      }));
      
    }
    fetchData();
    return () => {
      
    };
  }, []);


  
  useEffect(() => {                 
    //  console.log("This is from inside useeffect " + JSON.stringify(v1inv,null,2))
      // Calculations for the Measures below

      // Total Investments      
      const sumIvalL = v1inv.reduce((accumulator, currentValue) => {
        return accumulator + parseFloat(currentValue.ival_l);
      }, 0);      
      settotal_inv(sumIvalL);
      // console.log("1. Total Investments is "+ (total_inv) + ".");

      // Current Value Total      
      const sumCvalL = v1inv.reduce((accumulator, currentValue) => {
        return accumulator + parseFloat(currentValue.Cval_l);
      }, 0);      
      setcurrent_value(sumCvalL);
      // console.log("2. Total current value is "+ (current_value) + ".");

      // Unrealized P&L Value Total      
      const pnl = v1inv.reduce((accumulator, currentValue) => {
        return accumulator + parseFloat(currentValue.pnl);
      }, 0);      
      setpnl(pnl);
      // console.log("3. Total pnl is "+ (pnl) + ".");   
      
      // Funds Invested      
      const distinctFundsCount = [...new Set(v1inv.map(investment => investment.fundname))].length;
      setfunds_invested(distinctFundsCount);
      // console.log("4. Funds Invested "+ (funds_invested) + ".");

      // Startups Covered
      const distinctSUCount = [...new Set(v1inv.map(investment => investment.startupname))].length;
      setstartups_covered(distinctSUCount);
      // console.log("5. Startups Covered "+ (funds_invested) + ".");

      // Domains Covered
      const distinctdomainCount = [...new Set(v1inv.map(investment => investment.SU_Domain))].length;
      setdomains_covered(distinctdomainCount);

      // Use reduce to find the latest date
      const latestDate = v1inv.reduce((latest, item) => {
        const itemDate = new Date(item.issuedate2);
        return itemDate > latest ? itemDate : latest;
      }, new Date('1900-01-01'));
      // Format the latest date as 'dd-Mmm-yyyy'
      const formattedDate = latestDate.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      });
      setlatest_date(formattedDate);    
      
      //reverse chronologically arranged dates for the table data
      settdata([...v1inv].sort((a, b) => {
        const dateA = new Date(a.issuedate2);
        const dateB = new Date(b.issuedate2);
        return dateB - dateA;
      }));
      

    },  [v1inv]);


// below for dropdowns

const ITEM_HEIGHT = 158;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      fontSize:12,
      width: 250,
    },
  },
};

// checkbox for funds
const checks_funds = [...new Set(originalData.map(item => item.fundname))];
const [cfundsName, setcfundsName] = useState([]);
const handleChangecfunds = (event) => {
  const { value } = event.target;
  const selectedFunds = Array.isArray(value) ? value : [value];
  setcfundsName(selectedFunds);

  // Filter v1inv array by selected funds
  const filteredV1inv = selectedFunds.length > 0 ? originalData.filter((item) =>
    selectedFunds.includes(item.fundname)
  ) : originalData;

  // Set v1inv state to filtered v1inv array
  setv1inv(filteredV1inv);
  // console.log(JSON.stringify(v1inv, null, 2))
};


// checkbox for funds
  const checks_startup = [...new Set(originalData.map(item => item.startupname))];
  const [cstartupName, setcstartupName] = useState([]);
  const handleChangecstartup = (event) => {
  const { value } = event.target;
  const selectedStartups = Array.isArray(value) ? value : [value];
  setcstartupName(selectedStartups);

  // Filter v1inv array by selected funds
  const filteredV1inv = selectedStartups.length > 0 ? originalData.filter((item) =>
  selectedStartups.includes(item.startupname)
  ) : originalData;

  // Set v1inv state to filtered v1inv array
  setv1inv(filteredV1inv);
  // console.log(JSON.stringify(v1inv, null, 2))
};


// checkbox for Domain
  const checks_domain = [...new Set(originalData.map(item => item.SU_Domain))];
  const [cdomainName, setcdomainName] = useState([]);
  const handleChangecdomain = (event) => {
  const { value } = event.target;
  const selectedDomains = typeof value === 'string' ? value.split(',') : value;
  setcdomainName(selectedDomains);

  // Filter v1inv array by selected funds
  const filteredV1inv = selectedDomains.length > 0 ? originalData.filter((item) =>
  selectedDomains.includes(item.SU_Domain)
  ) : originalData;

  // Set v1inv state to filtered v1inv array
  setv1inv(filteredV1inv);
  // console.log(JSON.stringify(v1inv, null, 2))
};

// above for dropdowns

//____________________________________________________________________________________________________
// Data and options for Startups Composition waterfall chart

  // prepping data for wf step1 grouping startups,
  const startupsandcvsum = {};
  for (let i = 0; i < v1inv.length; i++) {
    const startup = v1inv[i];
    const startupName = startup.startupname;
    const Cval_l = parseFloat(startup.Cval_l);

    if (startupsandcvsum[startupName]) {
      startupsandcvsum[startupName].Cval_l += Cval_l;
    } else {
      startupsandcvsum[startupName] = {
        startupname: startupName,
        Cval_l: Cval_l,
      };
    }
  }
  const startupsandcvsumfinal = Object.values(startupsandcvsum);
  // console.log(JSON.stringify(startupsandcvsum, null, 2));
  let startupsData = {};
  startupsandcvsumfinal.sort((a, b) => parseFloat(b.Cval_l) - parseFloat(a.Cval_l));
  let total = 0;
  for (let i = 0; i < startupsandcvsumfinal.length; i++) {
    const startup = startupsandcvsumfinal[i];
    const currentValue = [total, total + parseFloat(startup.Cval_l)];
    startupsData[startup.startupname] = currentValue.join(",");
    total += parseFloat(startup.Cval_l);
  }
  startupsData["Total"] = `0,${total}`;  

  const labels = Object.keys(startupsData);
  const colors = [];
  for (let i = 0; i < labels.length; i++) {
    if (labels[i] !== "Total") {
      colors.push("#2E927C"); // color for startups
    } else {
      colors.push("#3281B7"); // color for total
    }
  }

  const startups_composition_data = {
    labels: labels,
    datasets: [
      {
        data: Object.values(startupsData).map((value) => {
          const numbers = value.split(",");
          return [Number(numbers[0]), Number(numbers[1])];
        }),
        backgroundColor: colors,
        barPercentage: 1.2,
      },
    ],
  };  
  
  // options for the chart
  const startups_composition_options  = {    
    labels:{
      display:false
    },
    scales: {
              x: {
                title:{
                  display: true,
                  text: 'Startup Name',
                  color: 'black',   
                  font:{
                    Family:"FF DIN",
                    size:'12',     
                    // weight:'bold'
                  }
                },
                grid: {
                  drawOnChartArea: false
                },
                // ticks:{
                //   callback: function(value, index, ticks) {
                //     return '₹'+ value+'L';
                //   }
                // }
              },
              y:{
                beginAtZero:true
                ,
                title:{
                  display: true,
                  text: 'Current Value',
                  color: 'black',   
                  font:{
                    Family:"Segoe UI",
                    size:'12',     
                    // weight:'bold'
                  }
                },
                grid: {
                  drawOnChartArea: true,
                  // color: '#F7F7F7'
                },
                ticks:{
                  callback: function(value, index, ticks) {
                    return '₹'+ value+'L';
                  }
                },
                border: {
                  dash: [2,4]
                }
              } 
    },    
    //circumference: 0,
    layout: {
      padding: {
        top:20,
        bottom:15
      },
    }
    ,
    
    plugins: {      
      tooltip: {
        enabled: true,
        backgroundColor: "white",
        bodyColor: "Black",
        titleColor: "Black",        
        callbacks: {
          label: function(context) {
            var label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            var value = context.dataset.data[context.dataIndex];
            value = value.toString(); 
            var parts = value.split(','); 
            if (parts.length === 1) {
              return label += "Current Value: " +'₹' + parts[0] + 'L';              
            } else if (parts.length === 2) {
              var result = (parseFloat(parts[1]) - parseFloat(parts[0])).toFixed(2); 
              return label += "Current Value: " +'₹' + result + 'L'; 
            } else {
              return ''; 
            }           
          }
        }        
      },
      legend: {
        display: false,
        position: "right",
        align: "right",
      },
      datalabels: {
        display: 'true',
         align: 'start',
         anchor: 'end',
          //  color:'contrast',
          color:'Black',
          offset: -20,
        // backgroundColor: 'none',        
        font:{
          Family:"Segoe UI",
          size:'14',     
          // weight:'bold'   
        },
        borderRadius:'5',
        formatter: function(value, context) {
          value = value.toString(); 
          var parts = value.split(','); 
          if (parts.length === 1) {
            return '₹' + parts[0] + 'L'; 
          } else if (parts.length === 2) {
            var result = (parseFloat(parts[1]) - parseFloat(parts[0])).toFixed(2); 
            return '₹' + result + 'L'; 
          } else {
            return ''; 
          }
        },
        
        
        
      },
    },
    responsive: true,
    maintainAspectRatio: false,
};

//_______________________________________________________________

  const fundsData = {};
  v1inv.forEach((item) => {
    if (!fundsData[item.fundname]) {
      fundsData[item.fundname] = 0;
    }
    fundsData[item.fundname] += parseFloat(item.Cval_l);
  });
  
  const domainDataa = {}; 
  v1inv.forEach((item) => {
    if (!domainDataa[item.SU_Domain]) {
      domainDataa[item.SU_Domain] = 0;
    }
    domainDataa[item.SU_Domain] += parseFloat(item.Cval_l);
  });
  ///sorting the above data in descending order
  const domainData = Object.entries(domainDataa)
  .sort((a, b) => b[1] - a[1])
  .reduce((acc, [key, value]) => {
    acc[key] = value;
    return acc;
  }, {});

  // data amd options for funds composition
  const funds_composition_data = {
    labels: Object.keys(fundsData),
    datasets: [
      {
        data: Object.values(fundsData).map((value) => value),
        backgroundColor: ["#3281B7","#2E927C","#EF9921","#7EA8C2","#73A59C","#F7CC8B","#E87934","#666666","#3599B8","#DFBFBF","#4AC5BB","#5F6B6D","#F4D25A","#7F898A","#A4DDEE","#FDAB89"],
      },
    ],
  };
  const funds_composition_options = {
    //circumference: 0,
    // radius: "100%",
    // cutout :"60%",
    radius: "70%",
    layout: {
      padding: 25,
    },
    // zoomOutPercentage: "60",
    plugins: {
      /*
      datalabels: {
      align: 'center',
      anchor: 'end',
      backgroundColor: 'white',
      borderRadius:'5',
      display: false,
      formatter:(value,context) => {
        return context.chart.data.labels[context.dataIndex] + ': '+ `${value}%`;
      }
      },*/
      outlabels: {
        display: true,        
        // text: "%l \n₹%v.2L (%p.2) ",
        // text: "%l ₹%v.2L",
        text: "₹%v.2L (%p.2)",
        color: "black",
        // lineColor: "#4C4A48",
        lineWidth: "1",        
        stretch: 2,
        font: {
          resizable: false,
          family: "Segoe UI",
          size: "12",
        },
        // backgroundColor: false,
        // formatter: function (value, context) {
        //   var percentage = context.dataset.percentages[context.dataIndex];
        //   if (percentage > 5) {
        //     return '';
        //   } else {
        //     return value;
        //   }
        // }
      },
      
      tooltip: {
        enabled: true,
        backgroundColor: "white",
        bodyColor: "Black",
        titleColor: "Black",
        callbacks: {
          label: function(context) {
            var label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            var value = context.dataset.data[context.dataIndex];
            var total = context.dataset.data.reduce((acc, val) => acc + val, 0);
            var percentage = ((value / total) * 100).toFixed(2);
            var result = value.toFixed(2);
            label += "Current Value: " + '₹' + result + 'L' + " (" + percentage + "% of Total)";
            return label;
          }
        } 
      },
      
      title: {
        display: false,
        align: "start",
        text: "Current Valuation of Holdings - Startups",
        color: "Black",
        fontFamily: "Arial",
        fontSize: "18",
        padding: { bottom: 20 },
      },
      legend: {
        display: true,
        position: "top",
        align: "center",
      },
    },
    //customCanvasBackgroundColor: {
    //  color: 'white',
    //},
    responsive: true,
    maintainAspectRatio: false,
    //  plugins: [
    //    ChartPieChartOutlabels
    //  ]
  };

  //___________________________________________________________


  // data and options for domain composition horizontal chart

  const domain_composition_data = {
    labels: Object.keys(domainData),
    datasets: [
      {
        data: Object.values(domainData).map((value) => value),
        backgroundColor: ["#3281B7","#2E927C","#EF9921","#7EA8C2","#73A59C","#F7CC8B","#E87934","#666666","#3599B8","#DFBFBF","#4AC5BB","#5F6B6D","#F4D25A","#7F898A","#A4DDEE","#FDAB89"],
        barPercentage : 1.0
      },
    ],
  };
  // console.log(JSON.stringify(domain_composition_data,null,2))
  // console.log(JSON.stringify(v1inv, null, 2))

  const domain_composition_options  = {
    indexAxis: 'y', 
    labels:{
      display:true
    },
    scales: {
              x: {
                title:{
                  display: true,
                  text: 'Current Value',
                  color: 'black',   
                  font:{
                    Family:"FF DIN",
                    size:'12',     
                    // weight:'bold'
                  }
                },
                grid: {
                  drawOnChartArea: false
                },
                ticks:{
                  callback: function(value, index, ticks) {
                    return '₹'+ value+'L';
                  }
                }
              },
              y:{
                title:{
                  display: true,
                  text: 'Startup Domain',
                  color: 'black',   
                  font:{
                    Family:"Segoe UI",
                    size:'12',     
                    // weight:'bold'
                  }
                },
                grid:{
                  drawOnChartArea:false
                }              
              } 
    },    
    //circumference: 0,
    layout: {
      padding: {
        top:20,
        bottom:15
      },
    },
    
    plugins: {      
      tooltip: {
        enabled: true,
        backgroundColor: "white",
        bodyColor: "Black",
        titleColor: "Black",  
        callbacks: {
          label: function(context) {
            var label = context.dataset.label || '';
            if (label) {
              label = "Current Value: ";
            }
            var value = context.dataset.data[context.dataIndex];            
            var result = Number(value).toFixed(2); 
            label += "Current Value: " + '₹' + result + 'L';
            return label;
          } 
        }                     
      },
      legend: {
        display: false,
        position: "right",
        align: "right",
      },
      datalabels: {
        display: 'true',
         align: 'start',
         anchor: 'end',
         color:'contrast',
        // backgroundColor: 'none',        
        font:{
          Family:"Segoe UI",
          size:'14',     
          weight:'bold'   
        },
        borderRadius:'5',
        formatter: function(value, context) {
          return '₹'+ Number(value).toFixed(2) +'L';
        },
      },
    },
    responsive: true,
    maintainAspectRatio: false,
};
//______________________________________________________________


  function getColor(ctx) {
    const colors = ["#3281B7", "#2E927C", "#EF9921", "#7EA8C2", "#73A59C", "#F7CC8B", "#E87934", "#666666", "#3599B8", "#DFBFBF", "#4AC5BB", "#5F6B6D", "#F4D25A", "#7F898A", "#A4DDEE", "#FDAB89"];
    // console.log(ctx);
    if (ctx.type === "data") {
      return colors[ctx.raw._data._idx];
    } else return "Black";
  }


  // // re-render for pie
  // const [chartData, setChartData] = useState(funds_composition_data);
  // const chartRef = useRef(null);
  
  // useEffect(() => {
  //   const resizeHandler = () => {
  //     const chartInstance = chartRef.current.chartInstance;
  //     if (chartInstance) {
  //       // Update the chart data as needed
  //       const newChartData = { ...funds_composition_data };
  //       setChartData(newChartData);
  //       chartInstance.update();
  //     }
  //   };
  
  //   window.addEventListener("resize", resizeHandler);
  
  //   // Clean up the event listener on component unmount
  //   return () => {
  //     window.removeEventListener("resize", resizeHandler);
  //   };
  // }, [funds_composition_data, v1inv]);

  

  return (
    <div>
      <Helmet>
                <title>Finvolve - Investor Dashboard</title>
                <link rel="icon" type="image/png" href={favicon} 
                sizes="16x16" 
                />
        </Helmet>
      {/* First item on the top, second item on the top in mobile view  */}

      <Grid container sx={{ backgroundColor: "#F7F7F7", border: { xs: "none", lg: "none" } }}>

        <Grid item xs={12} sm={6} lg={6} order={{ xs: 2, sm: 2, md: 2, lg: 1 }} sx={{border:'none'}}
        container
        display={'flex'}
        justifyContent={'flex-start'}>    


        <Button startIcon={<MenuIcon />} size="large" onClick={handleClickOpen}></Button>
        
        <Dialog disableEscapeKeyDown open={open} onClose={handleClose} >
        <DialogTitle sx={{backgroundColor: "#F7F7F7" }}>Filter Selection Menu</DialogTitle>
        <DialogContent sx={{ width: 320, height: 180, backgroundColor: "#F7F7F7"  }}>
          <Box component="form" sx={{ display: 'flex', flexWrap: 'wrap', backgroundColor: "#F7F7F7" }}>
          <Grid
          container
          display={"flex"}
          // direction={"row-reverse"}
          sx={{ backgroundColor: "#F7F7F7" }}
          // sx={{ border: "solid"}}
         >       
        <Grid item lg={12}>
        <FormControl sx={{ m: 1, width: 300 }} size="small">
        <InputLabel id="demo-multiple-checkbox-label">Funds</InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple          
          value={cfundsName}
          onChange={handleChangecfunds}
          input={<OutlinedInput label="Funds" />}
          renderValue={(selected) => selected.join(', ')}
          MenuProps={MenuProps}
        >
          {checks_funds.map((name) => (
            <MenuItem key={name} value={name} style={{ fontSize: 12 }}> 
              <Checkbox checked={cfundsName.indexOf(name) > -1} />
              <ListItemText primary={name} />
            </MenuItem>
          ))}
        </Select>
        </FormControl>
        </Grid>
        <Grid item>
        <FormControl sx={{ m: 1, width: 300 }}size="small">
        <InputLabel id="demo-multiple-checkbox-label">Startup</InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          value={cstartupName}
          onChange={handleChangecstartup}
          input={<OutlinedInput label="Startup" />}
          renderValue={(selected) => selected.join(', ')}
          MenuProps={MenuProps}
        >
          {checks_startup.map((name) => (
            <MenuItem key={name} value={name}>
              <Checkbox checked={cstartupName.indexOf(name) > -1} />
              <ListItemText primary={name} />
            </MenuItem>
          ))}
        </Select>
        </FormControl>
        </Grid>
        <Grid item>
        <FormControl sx={{ m: 1, width: 300 }} size="small">
        <InputLabel id="demo-multiple-checkbox-label">Domain</InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          value={cdomainName}
          onChange={handleChangecdomain}
          input={<OutlinedInput label="Domain" />}
          renderValue={(selected) => selected.join(', ')}
          MenuProps={MenuProps}
        >
          {checks_domain.map((name) => (
            <MenuItem key={name} value={name}>
              <Checkbox checked={cdomainName.indexOf(name) > -1} />
              <ListItemText primary={name} />
            </MenuItem>
          ))}
        </Select>
        </FormControl>
        </Grid>
      </Grid>
          </Box>
        </DialogContent>
        <DialogActions sx={{backgroundColor: "#F7F7F7"}} >          
          <Button onClick={handleClose}>Ok</Button>
        </DialogActions>
      </Dialog>   



      <Typography 
          pl={{ xs: 0, lg: 0 }} 
          pt={{ xs: 0, lg: 1 }} 
          pb={{ xs: 0, lg: 1 }} 
          m={0} 
          fontFamily="Segoe UI" variant={"h6"}>
                Hi, {iname}
              </Typography>
        </Grid>
        <Grid item pt={1} xs={12} lg={6} sx={{ border: "none" }} 
        order={{ xs: 1, sm: 1, md: 1, lg: 2 }}
        pr={{xs:0,lg:7}}        
        >
          <Grid 
          display={"flex"} 
          direction={{xs:"row", lg:"row-reverse"}} 
          justifyContent={{xs:"flex-start", lg:"end"}}          
          pr={1} mt={0} 
          container 
          sx={{ backgroundColor: "#F7F7F7" }} 
          border={"none"}          
          >            
              

            <Grid item pl={{xs:2, lg:2}} pt={{xs:0,lg:1}} sx={{ border: "none" }} xs={6} lg={2} pr={{xs:3, lg:3}} mr={4}> 
              <img src={iconforfvlogo} alt="Finvolve Logo" 
              style={{ 
                maxWidth: "180px", maxHeight: "180px", paddingRight: "10px"
                }} />
            </Grid>
            <Grid item pt={{lg:3}} pl={{xs:0, lg:0}} xs={6} lg={5} sx={{border: "none"}} align={{lg:"right"}}>
              {/* <Typography fontFamily="Segoe UI" fontSize={{xs:12,lg:16}}  align="right">
                Investor ID :- {iid} ({current_date})
              </Typography> */}
              <Typography fontFamily="Segoe UI" fontSize={{ xs: 12, lg: 16 }} fontWeight={"bold"} align="right">
                <Link href = "/investor-password-reset"  underline="always">Reset Password</Link> &nbsp; &nbsp;
                <Link href = "/investor-login" onClick={handleLinkClickfv} underline="always">Sign Out</Link>
              </Typography>              
               
            </Grid> 
           
          </Grid>
        </Grid>
      </Grid>
      < Grid container>
        <Grid item lg={12}>
          <Divider sx={{ color: "#DBDBDB" }}></Divider>
        </Grid>
      </Grid>
      <Grid
        container
        display={"flex"}        
        sx={{ backgroundColor: "#F7F7F7" }}
        //sx={{ border: "solid"}}
      >
        <Grid item pl={{xs:2, lg:5}} pt={{xs:0,lg:1}}>
          <HailIcon pt={5} fontSize="small" color="success"></HailIcon>
        </Grid>
        <Grid item pl={{xs:1, lg:0}} pt={{xs:0,lg:0}} lg={5}>
          <Typography m={{xs:0,lg:1}} fontFamily="Segoe UI" fontSize={16}>
            {" "}
            Wealth Manager :- {wealth_manager}
          </Typography>
        </Grid>
        <Grid item>
        
        </Grid>
      </Grid>
      <Grid
        container
        sx={{ backgroundColor: "#F7F7F7" }}
        display={"flex"}
        justifyContent="space-evenly"
        pl={{xs:0, lg:2}}
        pt={{xs:1, lg:1}}
        //sx={{ border: "solid"}}
      >
        <Grid item pt={{xs:1}} pr={{xs:0,lg:2}} xs={5} lg={2}>
          <Paper 
          // maxHeight={{xs:100}}
          >
            <img src={iconfortotalinvestment} alt="Total Investment" style={{ float: "left", margin: 10, border:'none' }} />
            {/* <img src={logo}  style={{ width: 300, height: 35 }}/> */}
            {/* <Typography fontFamily="Segoe UI" fontSize={30} color='#000000' align='right' pr={2}> {formatter.format(t_amt_inv)} Cr </Typography> */}
            <Typography fontFamily="Segoe UI" fontSize={{xs:22, lg:30}} color="#000000" align="right" pr={2}>
              {" "}
              {formatter.format(total_inv)}L{" "}
            </Typography>
            <Typography fontFamily="Segoe UI" fontSize={14} color="#80898A" align="right" pr={2} pb={{xs:1,lg:1}}>
              {" "}
              Total Investments{" "}
            </Typography>
          </Paper>
        </Grid>
        <Grid item pt={{xs:1}}  pr={{xs:0,lg:2}} xs={5} lg={2}>
          <Paper>
            <img src={iconforcurrentvalue} alt="Current Value" style={{ float: "left", margin: 10 }} />
            {/* <Typography fontFamily="Segoe UI" fontSize={30} color='#000000' align='right' pr={2}> {formatter.format(t_curr_val)} Cr </Typography> */}
            <Typography fontFamily="Segoe UI" fontSize={{xs:22, lg:30}} color="#000000" align="right" pr={2}>
              {" "}
              {formatter.format(current_value)}L {" "}
            </Typography>
            <Typography fontFamily="Segoe UI" fontSize={14} color="#80898A" align="right" pr={2} pb={{xs:1,lg:1}}>
              {" "}
              Current Value{" "}
            </Typography>
          </Paper>
        </Grid>
        <Grid item pt={{xs:1}} pr={{xs:0,lg:2}} xs={5} lg={2}>
          <Paper>
            <img src={iconfortotalpnl} alt="Total P&L" style={{ float: "left", margin: 10 }} />
            {/* <Typography fontFamily="Segoe UI" fontSize={30} color='#000000' align='right' pr={2} sx={{ color: t_pnl >= 0 ? 'green' : 'red' }}> {formatter.format(t_pnl)} Cr </Typography> */}
            <Typography fontFamily="Segoe UI" fontSize={{xs:22, lg:30}} color="#000000" align="right" pr={2} 
            sx={{ color: pnl >= 0 ? "green" : "red" }}
            >
              {" "}
              {formatter.format(pnl)} L{" "}
            </Typography>
            {/* <Typography fontFamily="Segoe UI" fontSize={14} color='#000000' align='right' pr={2} sx={{ color: t_pnl >= 0 ? 'green' : 'red' }}>+35.00%</Typography> */}
            <Typography fontFamily="Segoe UI" fontSize={14} color="#80898A" align="right" pr={2} border={'none'}  pb={{xs:1,lg:1}}>
              {" "}
              Unrealized P&L{" "}
            </Typography>
          </Paper>
        </Grid>
        
        
        <Grid item pt={{xs:1}} pr={{xs:0,lg:2}} xs={5} lg={2}>
          <Paper>
            <img src={iconforstartups} alt="Startups" style={{ float: "left", margin: 10 }} />
            {/* <Typography fontFamily="Segoe UI" fontSize={30} color='#000000' align='right' pr={2}> {formatter.format(t_amt_inv)} Cr </Typography> */}
            <Typography fontFamily="Segoe UI" fontSize={{xs:22, lg:30}} color="#000000" align="right" pr={2}>
              {" "}
              {startups_covered}{" "}
            </Typography>
            <Typography fontFamily="Segoe UI" fontSize={14} color="#80898A" align="right" pr={2} pb={{xs:1,lg:1}}>
              {" "}
              Startups Covered{" "}
            </Typography>
          </Paper>
        </Grid>
        
        <Grid item pt={{xs:1}} pr={{xs:0,lg:2}} xs={5} lg={2}>
          <Paper>
            <img src={iconfordomains} alt="Domains Covered" style={{ float: "left", margin: 10 }} />
            {/* <Typography fontFamily="Segoe UI" fontSize={30} color='#000000' align='right' pr={2} sx={{ color: (t_curr_val / t_amt_inv) >= 1 ? 'green' : 'red' }}> {formatter.format(t_curr_val / t_amt_inv)}x </Typography> */}
            <Typography fontFamily="Segoe UI" fontSize={{xs:22, lg:30}} color="#000000" align="right" pr={2}>
              {" "}
              {domains_covered}{" "}
            </Typography>
            <Typography fontFamily="Segoe UI" fontSize={14} color="#80898A" align="right" pb={{lg:1}} pr={2} display={{xs:'none', lg:'block'}}>
              {" "}
              Domains Covered{" "}
            </Typography>
            <Typography fontFamily="Segoe UI" fontSize={14} color="#80898A" align="right" pr={2}  pb={{xs:1,lg:1}} display={{lg:'none'}}>
              {" "}
              Domains Covered{" "}
            </Typography>
          </Paper>
        </Grid>
        <Grid item pt={{xs:1}} pr={{xs:0,lg:2}} xs={5} lg={2}>
          <Paper>
            <img src={iconforlatestdate} alt="Latest date of Investment" style={{ float: "left", margin: 10 }} />
            {/* <Typography fontFamily="Segoe UI" fontSize={30} color='#000000' align='right' pr={2}> {formatter.format(t_amt_inv)} Cr </Typography> */}
            <Typography fontFamily="Segoe UI" fontWeight={'500'} fontSize={{xs:22, lg:20}} color="#000000" align="right" pr={2} pb={{xs:0,lg:1}} pt={{xs:0,lg:1}}>
              {latest_date}
            </Typography>
            <Typography fontFamily="Segoe UI" fontSize={14} color="#80898A" align="right" pr={2} pb={{xs:1,lg:1}}>
              {" "}
              Last Invested on{" "}
            </Typography>
          </Paper>
        </Grid>
      </Grid>
      <Grid
        container
        sx={{ backgroundColor: "#F7F7F7" }}
        display={"flex"}
        justifyContent="start"
        pt={0}
        mb={-3}
        //sx={{ border: "solid" }}
      >
        {/* <Grid item p={{xs:3,lg:0}} pt={{xs:2,lg:1}} pl={{xs:3,lg:2}} xs={12} lg={4}>
          <Paper
            elevation={2}
            sx={{
              padding: "10px",
              maxWidth: "100%",
              height: "320px",
              borderRadius: "10px",
              border: "none",
            }}>
            <Typography fontFamily={"Arial"} fontSize={18} fontWeight={"bold"} color={"Black"} height={"6%"}>
              Funds Composition
            </Typography>
            <Doughnut data={funds_composition_data} plugins={[ChartPieChartOutlabels]} options={funds_composition_options} />            
          </Paper>
        </Grid> */}
        <Grid item p={{xs:3,lg:0}} pt={{xs:0,lg:1}} pl={{xs:3,lg:2}} xs={12} lg={6}>
          <Paper
            elevation={2}
            sx={{
              padding: "10px",
              maxWidth: "100%",
              height: "320px",
              borderRadius: "10px",
              border: "none",
            }}>
            <Typography fontFamily={"Arial"} fontSize={18} fontWeight={"bold"} color={"Black"} height={"6%"}>
              Startups Composition
            </Typography>
            <Bar data={startups_composition_data} plugins={[ChartDataLabels]} options={startups_composition_options}/>            
          </Paper>
        </Grid>
        <Grid item  p={{xs:3,lg:0}} pr={{lg:2}} pt={{xs:0,lg:1}} pl={{xs:3,lg:2}} xs={12} lg={6}>
          <Paper
            elevation={2}
            sx={{
              padding: "10px",
              maxWidth: "100%",
              height: "320px",
              borderRadius: "10px",
              border: "none",
            }}>
            <Typography fontFamily={"Arial"} fontSize={18} fontWeight={"bold"} color={"Black"} height={"6%"}>
              Domain Composition
            </Typography>
            <Bar data={domain_composition_data} plugins={[ChartDataLabels]} options={domain_composition_options} />            
          </Paper>
        </Grid>
      </Grid>
     
      <Grid
        pt={2}
        container
        display={"flex"}
        wrap="nowrap"
        sx={{ backgroundColor: "#F7F7F7" }}
        justifyContent="space-evenly"
        //sx={{ border: "solid" }}
      >
        <Grid item p={2} m={0} xs={12} lg={12}>
          <Paper
            sx={{
              padding: "10px",
              maxWidth: "100%",
              height: "300px",
              borderRadius: "10px",
            }}
            elevation={3}>
            <Typography fontFamily={"Arial"} fontSize={18} fontWeight={"bold"} color={"Black"}>
              {" "}
              Transaction Summary{" "}
            </Typography>
            <TableContainer m={1} p={1} sx={{ maxHeight: "100%", maxWidth: "100%" }}>
              <Table aria-label="simple table" size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        fontFamily: "Segoe UI",
                        fontSize: "18",
                        width: "40px",
                        color: "#A6A6A6",
                      }}
                      align="left">
                      {" "}
                      Issue Date{" "}
                    </TableCell>
                    {/* <TableCell
                      sx={{
                        fontFamily: "Segoe UI",
                        fontSize: "18",
                        width: "40px",
                        color: "#A6A6A6",
                      }}
                      align="left">
                      Fund
                    </TableCell> */}
                    <TableCell
                      sx={{
                        fontFamily: "Segoe UI",
                        fontSize: "18",
                        width: "40px",
                        color: "#A6A6A6",
                      }}
                      align="center">
                      Invested Startup
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: "Segoe UI",
                        fontSize: "18",
                        width: "40px",
                        color: "#A6A6A6",
                      }}
                      align="center">
                      Domain
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: "Segoe UI",
                        fontSize: "18",
                        width: "40px",
                        color: "#A6A6A6",
                      }}
                      align="center">
                      Round
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: "Segoe UI",
                        fontSize: "18",
                        width: "90px",
                        color: "#A6A6A6",
                      }}
                      align="center">
                      Units
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: "Segoe UI",
                        fontSize: "18",
                        width: "40px",
                        color: "#A6A6A6",
                      }}
                      align="center">
                      Avg. NAV
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: "Segoe UI",
                        fontSize: "18",
                        width: "40px",
                        color: "#A6A6A6",
                      }}
                      align="center">
                      Current NAV
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: "Segoe UI",
                        fontSize: "18",
                        width: "40px",
                        color: "#A6A6A6",
                      }}
                      align="center">
                      Amount Invested
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: "Segoe UI",
                        fontSize: "18",
                        width: "40px",
                        color: "#A6A6A6",
                      }}
                      align="center">
                      Current Value
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: "Segoe UI",
                        fontSize: "18",
                        width: "40px",
                        color: "#A6A6A6",
                      }}
                      align="center">
                      P&L
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: "Segoe UI",
                        fontSize: "18",
                        width: "40px",
                        color: "#A6A6A6",
                      }}
                      align="center">
                      P&L%
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tdata.map((tdata, index) => (
                    <TableRow key={index} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                      <TableCell
                        sx={{
                          fontFamily: "Segoe UI",
                          fontSize: "20",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                        }}
                        component="th"
                        scope="row">
                        {tdata.issuedate2}
                      </TableCell>
                      {/* <TableCell
                        sx={{
                          fontFamily: "Segoe UI",
                          fontSize: "20",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                        }}
                        align="left">
                        {tdata.fundname}
                      </TableCell> */}
                      <TableCell
                        sx={{
                          fontFamily: "Segoe UI",
                          fontSize: "20",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                        }}
                        align="center">
                        {tdata.startupname}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily: "Segoe UI",
                          fontSize: "20",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                        }}
                        align="center">
                        {tdata.SU_Domain}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily: "Segoe UI",
                          fontSize: "20",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                        }}
                        align="center">
                        {tdata.round}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily: "Segoe UI",
                          fontSize: "20",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                        }}
                        align="center">
                        {Number(tdata?.units)?.toFixed(2)}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily: "Segoe UI",
                          fontSize: "20",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                        }}
                        align="center">
                        ₹{tdata.unitprice}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily: "Segoe UI",
                          fontSize: "20",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                        }}
                        align="center">
                        ₹{tdata.Cunitprice}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily: "Segoe UI",
                          fontSize: "20",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                        }}
                        align="center">
                        {/* ₹{v1inv.ival_l.toFixed(2)}L */}
                        ₹{parseFloat(tdata.ival_l).toFixed(2)}L
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily: "Segoe UI",
                          fontSize: "20",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                        }}
                        align="center">
                        ₹{parseFloat(tdata.Cval_l).toFixed(2)}L
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily: "Segoe UI",
                          fontSize: "20",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                        }}
                        align="center">
                        ₹{parseFloat(tdata.pnl).toFixed(2)}L
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily: "Segoe UI",
                          fontSize: "20",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                        }}
                        align="center">
                        {parseFloat(tdata.pnlp).toFixed(2)}%
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>
      </Grid>
      <Grid
        container
        sx={{ backgroundColor: "#F7F7F7" }}
        display={"flex"}
        justifyContent="flex-start"
        pt={0}
        mt={-3}
        //sx={{ border: "solid" }}
      >
        <Grid item lg={6}>
          <Grid
            container
            display={"flex"}
            justifyContent="flex-start"
            pt={0}
            mt={0}
            //sx={{ border: "solid" }}
          ></Grid>
        </Grid>
        <Grid item lg={6}>
          <Grid
            container
            display={"flex"}
            direction={"row-reverse"}
            justifyContent="flex-start"
            pr={1}
            mt={0}
            //sx={{ border: "solid" }}
          >
            {/* <Grid item pl={{xs:0,lg:1}} pt={{xs:3,lg:3}} pr={{xs:0,lg:2}}>
              <img src={logo} alt="IA Logo" style={{ width: 300, height: 35 }} />
            </Grid>             */}
            <Grid item pl={{xs:3,lg:1}} pt={{xs:0,lg:5}} pr={{lg:2}}>
              <Typography fontFamily="Segoe UI" fontSize={16}>
                {" "}
                {/* Report Last Updated :- {rlatest_date}{" "} */}
                {/* Report Last Updated :- 08-APR-2025               */}
                </Typography>              
            </Grid>            
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
export default Dashh;